document.addEventListener("DOMContentLoaded", function () {
    var QOAddMoreLines = document.getElementById('QOAddMoreLines');
    var QOAddToCarts = document.getElementById('QOAddToCarts');

    if (QOAddMoreLines != null && QOAddToCarts != null) {
        QOAddMoreLines
            .addEventListener('click', AddMoreLines);
        QOAddToCarts
            .addEventListener('click', AddToCart);
    }

    function GetCommerceDomain() {
        if (window.location.hostname.includes("local")) {
            return "https://localcontent.promega.com";
        }

        if (window.location.hostname.includes("dev")) {
            return "https://devcloud.promega.com";
        }

        if (window.location.hostname.includes("stage")) {
            return "https://stagecloud.promega.com";
        }

        if (window.location.hostname.includes("test")) {
            return "https://test.promega.com";
        }

        return "https://www.promega.com";
    }

    function AddToCart() {

        var data = GetData();
        document.getElementsByClassName("loading-indicator--QuickOrder")[0].classList.add('loading-indicator--visible');
        window.location.href = GetCommerceDomain() + "/commerce/CommerceRedirect" + data;
    }

    function GetData() {
        var param = '?mqpartno=';
        var rows = document
            .getElementById('QOContainer')
            .getElementsByClassName('catalog-qty--row');
        for (var i = 0, row; (i < rows.length); i++) {
            var cell = new DOMParser().parseFromString(row, 'text/html');
            var product = document.getElementsByName(
                'catalog[' + i + '].ItemNumber'
            )[0];

            var qty = document.getElementsByName('catalog[' + i + '].Qty')[0];

            if (product != undefined && product.value != '') {
                if (qty.value != '')
                    param += product.value + '|' + qty.value + ':';
                else
                    param += product.value + '|1' + ':';
            }
        }
        if (param.indexOf(':') > 0) {
            param = param.substring(0, param.length - 1);
        }
        param += '&clear=False';
        return param;

    }

    function AddMoreLines() {
        var table = document
            .getElementById('QOContainer')
            .getElementsByClassName('catalog-qty--row');
        var lastRow = table[table.length - 1];
        var rowslength = table.length;
        for (var i = rowslength; i < rowslength + 3; i++) {
            var newRow = `<div class="grid catalog-qty--row">
              <div class="grid__span-8--chromosome">
                  <input
                    id="catalog_`+ i + `__ItemNumber"
                    name="catalog[`+ i + `].ItemNumber"
                    type="text"
                    value=""
                  />
                </div>
                <div class="grid__span-4--chromosome">
                  <input
                    data-val="true"
                    data-val-number="The field Qty must be a number."
                    data-val-required="The Qty field is required."
                    id="catalog_`+ i + `__Qty"
                    name="catalog[`+ i + `].Qty"
                    type="text"
                    value=""
                  />
                </div>
              </div>`;

            lastRow.insertAdjacentHTML('beforeend', newRow);
        }
    }
})